module.exports = __webpack_public_path__ + "static/media/calcutta_video.a1361b1e.mp4";